import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = (accountId, role) => [
  {
    icon: 'mail-inbox',
    key: 'inboxView',
    label: 'INBOX_VIEW',
    featureFlag: FEATURE_FLAGS.INBOX_VIEW,
    toState: frontendURL(`accounts/${accountId}/inbox-view`),
    toStateName: 'inbox_view',
  },
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
  },
  {
    icon: 'board',
    key: 'kanban',
    label: 'KANBAN',
    featureFlag: FEATURE_FLAGS.KANBAN,
    toState: frontendURL(`accounts/${accountId}/kanban`),
    toStateName: 'kanban_board',
  },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
    meta: {
      permissions: ['administrator', 'control', 'monitoring'],
    }
  },
  {
    icon: 'building-bank',
    key: 'companies',
    label: 'COMPANIES',
    featureFlag: FEATURE_FLAGS.COMPANIES,
    toState: frontendURL(`accounts/${accountId}/companies`),
    toStateName: 'companies_dashboard',
    meta: {
      permissions: ['administrator'],
    }
  },
  {
    icon: 'arrow-trending-lines',
    key: 'reports',
    label: 'REPORTS',
    featureFlag: FEATURE_FLAGS.REPORTS,
    // Agents can only access their own productivity report, so the Reports entry
    // lands them there; management roles land on the account overview as before.
    toState:
      role === 'agent'
        ? frontendURL(`accounts/${accountId}/reports/productivity`)
        : frontendURL(`accounts/${accountId}/reports`),
    toStateName:
      role === 'agent' ? 'productivity_reports' : 'account_overview_reports',
    meta: {
      permissions: ['administrator', 'agent', 'control', 'coordination', 'monitoring']
    }
  },
  {
    icon: 'megaphone',
    key: 'campaigns',
    label: 'CAMPAIGNS',
    featureFlag: FEATURE_FLAGS.CAMPAIGNS,
    toState: frontendURL(`accounts/${accountId}/campaigns`),
    toStateName: 'ongoing_campaigns',
    meta: {
      permissions: ['administrator'],
    }
  },
  {
    icon: 'library',
    key: 'helpcenter',
    label: 'HELP_CENTER.TITLE',
    featureFlag: FEATURE_FLAGS.HELP_CENTER,
    alwaysVisibleOnChatwootInstances: true,
    toState: frontendURL(`accounts/${accountId}/portals`),
    toStateName: 'default_portal_articles',
  },
  {
    icon: 'settings',
    key: 'settings',
    label: 'SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
    meta: {
      permissions: ['administrator'],
    }
  },
];

export default primaryMenuItems;
